import { useSelector, useDispatch } from "react-redux";
import LoyaltyOptInModal from "../../components/LoyaltyOptInModal";
import {
  getLoyaltyIsOptedIn,
  getLoyaltyIsEnabled
} from "../../state/modules/config/selectors";
import {
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject
} from "../../state/modules/analytics/actions";

import { getCategoryId } from "../../state/modules/category";
import { loyaltyOptIn } from "../../state/modules/config/actions";
import { getFeatures } from "../../featuresStore";

const ConnectedLoyaltyOptInModal = props => {
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const categoryId = useSelector(getCategoryId);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const dispatch = useDispatch();

  const { decisions } = getFeatures() || {};
  const loyaltyNewInExperimentEnabled = Boolean(
    decisions?.["loyalty-new-in-today-lock-product"]
  );

  return (
    <LoyaltyOptInModal
      {...props}
      categoryId={categoryId}
      loyaltyIsEnabled={loyaltyIsEnabled}
      loyaltyIsOptedIn={loyaltyIsOptedIn}
      loyaltyNewInExperimentEnabled={loyaltyNewInExperimentEnabled}
      loyaltyOptIn={() => dispatch(loyaltyOptIn())}
      analyticsLoyaltyOptInClick={() => dispatch(analyticsLoyaltyOptInClick())}
      analyticsLoyaltyOptInReject={() =>
        dispatch(analyticsLoyaltyOptInReject())
      }
    />
  );
};

export default ConnectedLoyaltyOptInModal;
